// extracted by css-extract-rspack-plugin
export default {"root":"RXmVNl","tabs":"yexjzM","tab":"M6PyXw"};